import {
  MessageLayout,
  MessageWrapper,
} from '@web/conversations/Message/MessageLayout/MessageLayout';
import { DateBubble } from '@web/components/DateBubble/DateBubble';

type Props = {
  date: Date;
  usTimeFormat?: boolean;
};

export const MessageDateSeparator = ({ date, usTimeFormat }: Props) => (
  <MessageLayout>
    <MessageWrapper>
      <DateBubble date={date} usTimeFormat={usTimeFormat} />
    </MessageWrapper>
  </MessageLayout>
);
